import type { Airflow } from '@aviata/platform-types';

import type { UNITS } from '../config';

export type LuggageUnit = (typeof UNITS)[keyof typeof UNITS];
export type LuggageFromAccounts = {
  unit: LuggageUnit;
  value: number;
  factor: number;
  pc?: {
    value: number;
    unit: LuggageUnit;
  };
};
export type Luggage = Airflow.Segment.Baggage | Airflow.Segment.HandLuggage;
